import { BufferRange } from "@nova/protobuf"
import { GeometryWithDistance } from "plugins/shared/layers/types"
import { createSlice } from "@reduxjs/toolkit"

export type FirePerimetersBufferState = {
    byPerimeterId: Record<string, GeometryWithDistance[]>
}

const initialState: FirePerimetersBufferState = {
    byPerimeterId: {},
}

const name = "fp-buffers"

const {
    reducer: firePerimeterBuffersReducer,
    actions: { setFirePerimeterBuffersForId, updateCachedFirePerimeterBuffersProperties },
} = createSlice({
    name,
    initialState,
    reducers: {
        setFirePerimeterBuffersForId: (
            state: FirePerimetersBufferState,
            action: { payload: { perimeterId: string; data: GeometryWithDistance[] } }
        ) => {
            state.byPerimeterId[action.payload.perimeterId] = action.payload.data
        },
        updateCachedFirePerimeterBuffersProperties: (
            state: FirePerimetersBufferState,
            action: { payload: { perimeterId: string; buffers: Omit<BufferRange, "distance">[] } }
        ) => {
            const perimeterId = action.payload.perimeterId

            action.payload.buffers.forEach((buffer, i) => {
                const existingBuffer = state.byPerimeterId[perimeterId][i]
                state.byPerimeterId[perimeterId][i] = {
                    ...existingBuffer,
                    color: buffer.color,
                    width: buffer.width,
                }
            })
        },
    },
})

export const reducer = { [name]: firePerimeterBuffersReducer }

export { setFirePerimeterBuffersForId, updateCachedFirePerimeterBuffersProperties }
